import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './CheckBox.scss';

class CheckBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: props.checked
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.checked !== this.props.checked) {
            this.setState({ isChecked: nextProps.checked });
        }
    }

    render() {
        const {
            name, text, onChange, disable, languageId
        } = this.props;
        return (
            <label className='fl-checkbox'>
                <label className='fancy-checkbox'>
                    <input
                        type='checkbox'
                        disabled={ disable ? 'disable' : undefined }
                        checked={ this.state.isChecked }
                        name={ name }
                        onChange={ onChange }
                        onClick={ this.handleChange } />
                    <span>{languageId !== 3 ? text : undefined}</span>
                </label>
            </label>
        );
    }

    handleChange = () => {
        this.setState({ isChecked: !this.state.isChecked });
    }
}

CheckBox.propTypes = {
    checked: PropTypes.bool,
    disable: PropTypes.bool,
    name: PropTypes.string,
    text: PropTypes.string,
    onChange: PropTypes.func,
    languageId: PropTypes.number
};

CheckBox.defaultProps = {
    checked: false,
    disable: false,
    name: '',
    text: '',
    onChange: null,
    languageId: 1
};

export default CheckBox;
